import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import TotalProductCount from './common/TotalProductCount';
import OptInPopup from "../components/OptInPopup";
import config from "../../config";

class Category extends Component {
	render() {
		const pageTitle = 'Cash Boxes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<TopProducts
					title={ `Best Selling ${pageTitle}` }
					subTitle="Versatile cash protection and organization"
					path="cash-boxes"
					buttonCTA={ `View all ${pageTitle}` }
					topProduct={ this.props.featuredProduct }
				/>
			);
		}

		return (
			<div className="category category-cash-boxes">
				<Helmet defer={false}>
					<title>{ pageTitle } &#124; SentrySafe</title>
					<meta name="description" content="SentrySafe cash boxes provide an easy way to keep your money safe, organized and protected. View cash boxes." />
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/cash-boxes.jpg') }
					imageAlt="Children playing in yard"
					title={ pageTitle }
					description="Protect your hard-earned money."
				/>

				<TrustedSection
					content="Whether you&rsquo;re running a business, hosting a fundraiser, or transporting cash for any reason, SentrySafe cash boxes provide an easy way to keep your money safe, organized and protected."
				/>

				{ topProducts }

				<section className="row hour-test">
					<div className="col sm-12">
						<h2 className="title">Convenience Meets Safety</h2>
					</div>
					<div className="callouts">
						<div className="col sm-3">
							<h3 className="sub-title">Security</h3>
							<p>Privacy key locks and steel construction keep your money and documents safe.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">Organization</h3>
							<p>Interior cash drawers and bill clips ensure cash, coins, checks and receipts stay organized.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">Portability</h3>
							<p>Small and medium cash boxes are lightweight and equipped with a handle for easy transportation.</p>
						</div>
					</div>
				</section>

				<TotalProductCount
					link="cash-boxes"
					productTotal={ totalCount }
					name={ pageTitle }
				/>
				<OptInPopup />
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/CashCategory.js